module.exports = __webpack_public_path__ + "img/fx-app.48607dac.png";